<template>
  <v-card>
    <v-card-title>
      <div class="headline">
        Редактирование пользователя
      </div>
    </v-card-title>
    <v-card-text>
      <v-form ref="userEditForm">
        <v-container>
          <v-row>
            <v-text-field
              v-model="user.username"
              label="Логин"
              :rules="inputRules"
              required
            />
          </v-row>
          <v-row>
            <v-text-field
              v-model="user.first_name"
              label="Имя"
              :rules="inputRules"
              required
            />
          </v-row>
          <v-row>
            <v-text-field
              v-model="user.last_name"
              label="Фамилия"
              :rules="inputRules"
              required
            />
          </v-row>
          <v-row>
            <v-text-field
                v-model="user.email"
                label="Email"
                :rules="inputRules"
                required
            />
          </v-row>
          <v-row>
            <v-chips-combobox
              :model="user.groups"
              :items="permissionsGroups"
              item-text="name"
              item-value="permissions_group_id"
              label="Группа"
            />
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="blue darken-1"
        text
        @click.native="saveChanges"
      >
        Сохранить
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click.native="cancelEditing"
      >
        Отмена
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import VChipsCombobox from '../../shared-components/VChipsCombobox'
export default {
  name: 'UserEdit',
  components: {
    VChipsCombobox
  },
  props: {
    userData: {}
  },
  data () {
    return {
      inputRules: [
        v => !!v || 'Заполните это поле!'
      ],
      user: {},
      users_groups: [],
      permissionsGroups: []
    }
  },
  mounted () {
    this.user = this.userData
    this.getPermissionsGroupsApi()
  },
  methods: {
    cancelEditing: function () {
      this.$emit('cancel')
    },
    getPermissionsGroupsApi () {
      this.loading = true
      this.axios.get(`/api/permissions_groups/?per_page=100`)
        .then((response) => {
          this.permissionsGroups = response.data.results
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    validate () {
      if (this.$refs.userEditForm.validate()) {
        return true
      }
    },
    saveChanges () {
      if (this.validate()) {
        this.axios.patch(`/api/users/${this.userData.user_id}/`, this.user)
          .then(() => {
            this.$emit('edited')
          })
          .catch((err) => {
            this.$emit('editError', err.response.data)
          })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/user/UserEdit.vue